<form [formGroup]="form" [glPremium]="true">
  <div class="maxFloorWrapper">
    <gl-checkbox
      [defaultChecked]="this.form.get('palletStacking').value"
      [ngClass]="{'disabledCheckbox': !isEdit}"
      class="checkbox"
      formControlName="palletStacking"
    >
      {{ 'stacking' | translate }}
    </gl-checkbox>
    <div class="maxFloor">
      <gl-input-container [ngClass]="{'disabled': !isEdit}" class="input">
        <input
          [numericType]="'float'"
          formControlName="palletFloorNumber"
          min="1"
          number-input
          placeholder="palletFloorNumber"
          type="number"
        />
      </gl-input-container>
      <div [glTooltip]="'pallet_floor_number'" class="info">i</div>
    </div>
  </div>
  <div class="floorWeightWrapper">
    <gl-checkbox
      [defaultChecked]="this.form.get('palletFloorWeight').value"
      [ngClass]="{'disabledCheckbox': !isEdit}"
      class="checkbox"
      formControlName="palletFloorWeight"
    >
      {{ 'floorWeight' | translate }}
    </gl-checkbox>
    <div class="floorWeight">
      <gl-input-container [ngClass]="{'disabled': !isEdit}" [units]="'weight'" class="input">
        <input
          [numericType]="'float'"
          formControlName="palletMaxWeight"
          normal-input
          placeholder="palletMaxWeight"
          type="number"
        />
      </gl-input-container>
      <div [glTooltip]="'pallet_max_weight'" class="info">i</div>
    </div>
  </div>
</form>
